import { createTheme } from '@mui/material/styles';
import { indigo, brown } from '@mui/material/colors';

export const FINVARI_BLUE = '#225796';

// Metrics chart colors — referenced by MetricsPage via theme.palette.metrics.*
declare module '@mui/material/styles' {
  interface Palette {
    metrics: {
      min: string;
      median: string;
      p90: string;
      max: string;
      succeeded: string;
      failed: string;
    };
  }
  interface PaletteOptions {
    metrics?: {
      min?: string;
      median?: string;
      p90?: string;
      max?: string;
      succeeded?: string;
      failed?: string;
    };
  }
}

export const getTheme = (mode: 'light' | 'dark') => {
  return createTheme({
    palette: {
      mode,
      primary: {
        ...indigo,
        main: FINVARI_BLUE,
        light: '#34a8f0',
        dark: '#173963',
      },
      secondary: {
        ...brown,
        main: '#966222', // #6d4c41 - nice warm brown
        light: '#c39059',
        dark: '#6e3b0c',
      },
      success: {
        main: '#2e7d32',
      },
      warning: {
        main: '#ed6c02',
      },
      error: {
        main: '#d32f2f',
      },
      background: {
        default: mode === 'light' ? '#f5f5f5' : '#121212',
        paper: mode === 'light' ? '#ffffff' : '#1e1e1e',
      },
      metrics: {
        min: '#4caf50',
        median: '#1976d2',
        p90: '#ff9800',
        max: '#d32f2f',
        succeeded: '#1976d2',
        failed: '#d32f2f',
      },
    },
    typography: {
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      h1: {
        fontSize: '2.5rem',
        fontWeight: 500,
      },
      h2: {
        fontSize: '2rem',
        fontWeight: 500,
      },
      h3: {
        fontSize: '1.75rem',
        fontWeight: 500,
      },
      h4: {
        fontSize: '1.5rem',
        fontWeight: 500,
      },
      h5: {
        fontSize: '1.25rem',
        fontWeight: 500,
      },
      h6: {
        fontSize: '1rem',
        fontWeight: 500,
      },
    },
    components: {
      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: 'none',
            borderRadius: 6,
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 8,
            boxShadow: mode === 'light' 
              ? '0 2px 8px rgba(0, 0, 0, 0.1)' 
              : '0 2px 8px rgba(0, 0, 0, 0.4)',
          },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: {
            borderRadius: 4,
          },
        },
      },
    },
  });
};

export const theme = getTheme('light');
